import { Routes, Route } from 'react-router-dom';
import Header from './components/Header';
import Footer from './components/Footer';
import ScrollToTop from './components/ScrollToTop';
import Forside from './pages/Forside';
import OmOs from './pages/OmOs';
import Kontakt from './pages/Kontakt';
import Error403 from './pages/Error403';
import Error404 from './pages/Error404';

function Layout({ children }) {
  return (
    <div className="flex flex-col min-h-screen bg-white text-slate-900 antialiased selection:bg-amber-100 selection:text-amber-900 relative">
      {/* Subtle luxury background grid lines */}
      <div className="absolute inset-y-0 left-1/2 -translate-x-1/2 w-full max-w-7xl px-6 md:px-12 grid grid-cols-6 gap-4 md:gap-8 pointer-events-none z-0 opacity-[0.03]">
        <div className="border-l border-navy-950 h-full"></div>
        <div className="border-l border-navy-950 h-full"></div>
        <div className="border-l border-navy-950 h-full"></div>
        <div className="border-l border-navy-950 h-full"></div>
        <div className="border-l border-navy-950 h-full"></div>
        <div className="border-l border-navy-950 h-full border-r"></div>
      </div>
      
      {/* Sticky Header */}
      <Header />
      
      {/* Main Content Area */}
      <main className="flex-grow relative z-10">
        {children}
      </main>
      
      {/* Elegant Footer */}
      <Footer />
    </div>
  );
}

export default function App() {
  return (
    <>
      {/* Scroll Restoration */}
      <ScrollToTop />
      
      <Layout>
        <Routes>
          {/* Main Pages */}
          <Route path="/" element={<Forside />} />
          <Route path="/om-os" element={<OmOs />} />
          <Route path="/kontakt" element={<Kontakt />} />
          
          {/* Error Pages */}
          <Route path="/403" element={<Error403 />} />
          <Route path="*" element={<Error404 />} />
        </Routes>
      </Layout>
    </>
  );
}
